import styled, { css } from 'styled-components';
import { Modal, Popover } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-input[disabled] {
    color: rgb(0 0 0 / 25%) !important;
    background-color: #f5f5f5 !important;
  }

  .ant-btn-danger {
    color: #fff;
    background-color: #ff4d4f;
  }

  input:active + label,
  input:hover + label,
  label:active,
  label:hover {
    border-color: #1890ff;
  }
`;

// ant overrides are fixes for the global overrides we have (but why?)
export const FieldWrapper = styled.div`
  margin: 15px 0;
`;

const FlexAlignCSS = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ActivationWrapper = styled.div`
  ${FlexAlignCSS}
`;

export const DatetimeWrapper = styled.div`
  ${FlexAlignCSS}
  .ant-calendar-picker-input.ant-input {
    border-color: #69c0ff;
    border-radius: 5px;
  }

  .ant-calendar-picker {
    margin-right: 5px;
    width: 100px;
  }
`;

export const TimeSelectorWrapper = styled.div`
  display: inline-block;

  .ant-select {
    min-width: 80px;
  }
`;

export const StyledPopover = styled(Popover)`
  margin-left: 5px;
`;
